enum MobileRecordingSettingsTypes {
  Set = 'mobileRecordingSettings.set',
  FetchRequest = 'mobileRecordingSettings.fetchRequest',
  FetchSuccess = 'mobileRecordingSettings.fetchSuccess',
  FetchFailure = 'mobileRecordingSettings.fetchFailure',
  UpdateRequest = 'mobileRecordingSettings.updateRequest',
  UpdateSuccess = 'mobileRecordingSettings.updateSuccess',
  UpdateFailure = 'mobileRecordingSettings.updateFailure',
}

export { MobileRecordingSettingsTypes };
